<template xmlns="http://www.w3.org/1999/html">
  <div>
    <vue-table
      :show-edit="false"
      :showDelete="false"
      :has-slot="true"
      :has-special-slot="true"
      :table-data="tableData"
      table-title="Archive"
      :fields="fields"
      :max-items="tableData.length"
    >
      <span slot-scope="row" slot="icons" style="width: 150px">
         <a v-if="!row.item.status || row.item.status.code !== 'PRIMARY'" @click="$emit('compare', row.item)" data-toggle="tooltip" title="Compare with Primary Quote" class="btn btn-primary">
           <em class="fa fa-eye"></em>
         </a>
      </span>
      <span slot-scope="row" slot="specialSlot">
       <select class="form-control" id="direction" @change="evt => updateJobStatus(evt, row.item)" :disabled="row.item.status && row.item.status.code === 'PRIMARY'">
          <option v-for="option in jobStatuses" :value="option.code" :selected="option.code === row.item.status.code">{{ option.name }}</option>
        </select>
        <div v-show="showCancelReason[row.item.id]">
          <div class="col-xs-12"><span class="pull-left">Enter cancel reason <span style="color: red">*</span></span></div>
          <div class="col-xs-12"><textarea class="pull-left" cols="20" style="width: 195px" v-model="cancelReason" /> </div>
          <div class="col-xs-12" style="margin-top: 5px"><input type="button" class="btn btn-sm btn-info pull-left" value="Submit" @click="enterCancelStatus(row.item)" /></div>
        </div>
        <div v-show="row.item.status && row.item.status.code === 'CANCELLED' && row.item.cancelReason" class="pull-left">
          <div style="white-space: nowrap">Reason: <mark>{{ row.item.cancelReason }}</mark></div>
        </div>
      </span>
      <span slot-scope="row" slot="specialSlotHeader">
        <div style="width: 200px;">Status</div>
      </span>
    </vue-table>
  </div>
</template>
<script>
  import VueTable from '../../../helpers/VueTable.vue'
  import API from '../../../../api/endpoints'
  import { dateFormat } from '../../../../util'
  export default {
    name: 'JobArchive',
    components: {
      VueTable
    },
    props: {
      masterJob: {
        type: Number,
        required: true
      },
      primaryId: {
        type: Number,
        required: true
      }
    },
    computed: {
      jobStatuses () {
        return this.$store.getters['systemOption/jobStatuses']
      }
    },
    data () {
      return {
        tableData: [],
        showCancelReason: {},
        newStatus: '',
        cancelReason: '',
        fields: [
          { header: 'Inquiry Ref', prop: item => item.inquiryRef },
          { header: 'Variation', prop: item => item.variation },
          { header: 'Created', prop: item => dateFormat(item.created) },
          { header: 'Pickup Date', prop: item => dateFormat(item.pickupDate) },
          { header: 'Job Type', prop: item => item.jobType && item.jobType.name },
          { header: 'Volume (CBM Net)', prop: item => item.volNetM3, numericalField: true },
          { header: 'ACW (Kilos)', prop: item => item.acwGrsKgs, numericalField: true }
        ]
      }
    },
    methods: {
      updateJobStatus (evt, job) {
        this.showCancelReason = {}
        this.newStatus = ''
        if (evt.target.value === 'CANCELLED' && !this.cancelReason) {
          job.status.code = evt.target.value
          this.showCancelReason[job.id] = true
          this.newStatus = evt.target.value
        } else if (evt.target.value && evt.target.value !== (job.status && job.status.code)) {
          this.$emit('updateStatus', job, evt.target.value, '')
        }
      },
      enterCancelStatus (job) {
        if (this.cancelReason) {
          this.$emit('updateStatus', job, this.newStatus, this.cancelReason)
        }
      },
      editQuote ({ item }) {
        this.$router.push({
          name: 'Add a new Quote',
          query: {
            masterJob: item.masterJob
          }
        })
      },
      getJobs () {
        if (this.masterJob) {
          this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('job'), {
            params: { masterJob: `!%!${this.masterJob}!%!` },
            headers: {
              'X-Lazy-Fetch': '1',
              'X-Order-By': 'ID DESCENDING'
            }
          }).then(({data}) => {
            let jobs = data.map(item => {
              if (item.id === this.primaryId) {
                return { ...item, hideIcons: true }
              }
              return item
            })
            this.setJobVolumes(jobs)
          }).catch(console.log)
        }
      },
      setJobVolumes (jobs) {
        let jobVolumePromises = []
        jobs.forEach(job => {
          jobVolumePromises.push(this.getJobVolumes(job))
        })
        Promise.all(jobVolumePromises)
          .then(jobVolumes => {
            if (jobVolumes.length) {
              jobVolumes.forEach(function (value, index) {
                if (value.body.length > 0) {
                  jobs[index].volNetM3 = value.body[0].volNetM3
                  jobs[index].acwGrsKgs = value.body[0].acwGrsKgs
                }
              })
            }
            this.tableData = jobs.sort((a, b) => a.status && a.status.code === 'PRIMARY' ? -1 : 1)
          }).catch(err => {
            this.tableData = jobs
            console.log(err)
          })
      },
      getJobVolumes (job) {
        return this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('job-volume'), {
          params: { job: job.id }
        })
      }
    },
    mounted () {
      this.getJobs()
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/admin/components/Job/JobArchive.vue